import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import EmailFoundation from '../../../../../../molecules/Email';
import './Email.css';
export default function Email(_ref) {
  var email = _ref.email;
  if (_isEmpty(email)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(EmailFoundation, {
    className: "email",
    email: email
  });
}